import { SvgIcon, SvgIconProps } from "@mui/material";

type IconProps = SvgIconProps & {
	size?: number;
};

export const UpArrowIcon = ({ size = 20, ...props }: IconProps) => {
	return (
		<SvgIcon width={size} height={size} viewBox="0 0 24 24" {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
				<path
					d="M5.75 0.75V12.4167M5.75 0.75L10.75 5.75M5.75 0.75L0.75 5.75"
					stroke="white"
					stroke-width="1.5"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</SvgIcon>
	);
};
